<template>
  <v-navigation-drawer
    class="d-print-none"
    color="blue-grey lighten-5"
    app
    v-model="sidebar.active"
    :mini-variant="sidebar.minimized"
    clipped
    bottom
  >
    <v-list dense class="cbc-menu">
      <v-list-item :to="{ name: 'dashboard' }">
        <v-list-item-icon>
          <v-icon color="primary">mdi-home</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{
            $lang("main.titles.dashboard")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item
        v-if="$can('VIEW_RESERVATION_TASKS')"
        :to="{ name: 'planner' }"
      >
        <v-list-item-icon>
          <v-icon color="primary">mdi-clipboard-text</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{
            $lang("main.titles.planner")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="$can('VIEW_RESERVATIONS')"
        :to="{ name: 'reservations' }"
      >
        <v-list-item-icon>
          <v-icon color="primary">mdi-format-list-text</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{
            $lang("main.titles.reservations")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="$can('BETA_FEATURE')"
        :to="{ name: 'payments-planned' }"
      >
        <v-list-item-icon>
          <v-icon color="primary">mdi-cash-multiple</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{
            $lang("main.titles.payments")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="$can('VIEW_RESERVATION_CALENDAR')"
        :to="{ name: 'calendar' }"
        color="orange darken-2"
      >
        <v-list-item-icon>
          <v-icon color="orange darken-2">mdi-chart-gantt</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">
            {{ $lang("main.titles.calendar") }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="$can('VIEW_RESERVATION_CALENDAR')"
        :to="{ name: 'reservations-calendar' }"
      >
        <v-list-item-icon>
          <v-icon color="grey">mdi-chart-gantt</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ $lang("main.titles.reservations_calendar") }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="$can('VIEW_RATE_CALENDAR')"
        :to="{ name: 'rate-calendar' }"
      >
        <v-list-item-icon>
          <v-icon color="grey">mdi-finance</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ $lang("main.titles.rate_calendar") }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-group v-if="$can('VIEW_QUOTES')" group="quotes">
        <template v-slot:activator>
          <v-list-item-icon>
            <v-icon color="primary">mdi-sale</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $lang("main.titles.quotes") }}
            </v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list-item :to="{ name: 'quote-requests' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-account-question</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              <v-badge content="beta">
                {{ $lang("main.titles.quote_requests") }}
              </v-badge>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="{ name: 'quotes' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-sale</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $lang("main.titles.quotes") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-item v-if="$can('VIEW_CLIENTS_LIST')" :to="{ name: 'clients' }">
        <v-list-item-icon>
          <v-icon color="primary">mdi-account-group</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{
            $lang("main.titles.clients")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-group v-if="$can('VIEW_RESOURCES')" group="resources">
        <template v-slot:activator>
          <v-list-item-icon>
            <v-icon color="primary">mdi-view-list</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.resources")
            }}</v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list-item :to="{ name: 'resources' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-clipboard-text</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.resources")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="{ name: 'resources-calendar' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-calendar</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $lang("main.titles.resources_calendar") }}</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-group v-if="$can('VIEW_HOUSEKEEPING')" group="housekeeping">
        <template v-slot:activator>
          <v-list-item-icon>
            <v-icon color="primary">mdi-spray-bottle</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.housekeeping")
            }}</v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list-item :to="{ name: 'housekeeping-planner' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-clipboard-text</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.planner")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="{ name: 'housekeeping-calendar' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-calendar</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.housekeeping_calendar")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="{ name: 'housekeeping-report' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-file-chart</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.housekeeping_report")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="{ name: 'housekeeping-report-by-unit' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-file-chart</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.housekeeping_report_by_unit")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-group v-if="$can('VIEW_WORK_ORDERS')" group="cmms">
        <template v-slot:activator>
          <v-list-item-icon>
            <v-icon color="primary">mdi-account-hard-hat</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.property_management")
            }}</v-list-item-title>
          </v-list-item-content>
        </template>
        <router-link v-if="$can('VIEW_WORKERS')" :to="{ name: 'workers' }">
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="primary">mdi-account-hard-hat</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{
                $lang("main.titles.workers")
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </router-link>
        <v-list-item v-if="$can('VIEW_ASSETS')" :to="{ name: 'Assets' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-book-multiple</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.assets")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="$can('VIEW_WORK_ORDERS')"
          :to="{ name: 'work-orders' }"
        >
          <v-list-item-icon>
            <v-icon color="primary">mdi-clipboard-list</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.work_orders")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-group v-if="$can('VIEW_REVENUE_MANAGEMENT')">
        <template v-slot:activator>
          <v-list-item-icon>
            <v-icon color="primary">mdi-home-analytics</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.revenue_management")
            }}</v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list-item :to="{ name: 'clusters' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-group</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.clusters")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="{ name: 'rmt' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-finance</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.rmt")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-group v-if="$can('VIEW_BILLS')" group="accounting">
        <template v-slot:activator>
          <v-list-item-icon>
            <v-icon color="primary">mdi-calculator-variant</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.accounting")
            }}</v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list-item :to="{ name: 'bills' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-receipt-text</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.bills")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="{ name: 'documents' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-text-box-check</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.documents")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="{ name: 'owner-documents' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-text-box-check</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.owner_documents")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="{ name: 'feeds-register-report' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-book-open</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.feeds_register")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="$can('VIEW_PAYMENTS_REPORT')"
          :to="{ name: 'payments-report' }"
        >
          <v-list-item-icon>
            <v-icon color="primary">mdi-cash-register</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.payments_report")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="$can('VIEW_PAYMENTS_REPORT')"
          :to="{ name: 'payments-cashflow' }"
        >
          <v-list-item-icon>
            <v-icon color="primary">mdi-format-list-bulleted</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.payments_cashflow")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-group
        v-if="$can('VIEW_POLICE_ACCOUNTS') || $can('VIEW_STAT_ACCOUNTS')"
        group="legal-compliance"
      >
        <template v-slot:activator>
          <v-list-item-icon>
            <v-icon color="primary">mdi-gavel</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.legal_compliance")
            }}</v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list-group sub-group>
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon color="primary" small>mdi-account-box-multiple</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{
                $lang("main.titles.accounts")
              }}</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item
            v-if="$can('VIEW_POLICE_ACCOUNTS')"
            :to="{ name: 'police-accounts' }"
          >
            <v-list-item-icon>
              <v-icon color="primary" small>mdi-police-badge</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{
                $lang("main.titles.police_accounts")
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="$can('VIEW_STAT_ACCOUNTS')"
            :to="{ name: 'stat-accounts' }"
          >
            <v-list-item-icon>
              <v-icon color="primary" small>mdi-chart-pie</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{
                $lang("main.titles.stat_accounts")
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-group sub-group>
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon color="primary" small>mdi-bank</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{
                $lang("main.titles.municipality_portals")
              }}</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item
            v-if="$can('VIEW_PAYTOURIST_ACCOUNTS')"
            :to="{ name: 'paytourist-accounts' }"
          >
            <v-list-item-icon>
              <v-icon color="primary" small>mdi-bank</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ $lang("main.titles.paytourist_accounts") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-item
          v-if="$can('VIEW_LEGAL_COMPLIANCE')"
          :to="{ name: 'legal-compliance-requests' }"
        >
          <v-list-item-icon>
            <v-icon color="primary">mdi-account-details</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.legal_compliance_requests")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="$can('VIEW_LEGAL_COMPLIANCE')"
          :to="{ name: 'legal-compliance-city-tax' }"
        >
          <v-list-item-icon>
            <v-icon color="primary">mdi-file-chart</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.city_tax_report")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="$can('VIEW_CONTRACTS')"
          :to="{ name: 'reservation-contracts' }"
        >
          <v-list-item-icon>
            <v-icon color="primary">mdi-file-certificate</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $lang("main.titles.reservation_contracts") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-group group="statistics">
        <template v-slot:activator>
          <v-list-item-icon>
            <v-icon color="primary">mdi-file-chart</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.reports")
            }}</v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list-item v-if="$can('VIEW_STATISTICS')" :to="{ name: 'revenues' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-chart-line</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.revenues_report")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="$can('VIEW_STATISTICS')"
          :to="{ name: 'production-report' }"
        >
          <v-list-item-icon>
            <v-icon color="primary">mdi-chart-line</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $lang("main.titles.production_report") }}</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="$can('VIEW_STATISTICS')"
          :to="{ name: 'audit-report' }"
        >
          <v-list-item-icon>
            <v-icon color="primary">mdi-chart-line</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $lang("main.titles.audit_report") }}</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="$can('VIEW_STATISTICS')"
          :to="{ name: 'reservations-report' }"
        >
          <v-list-item-icon>
            <v-icon color="primary">mdi-chart-pie</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.reservations_report")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="$can('VIEW_REVENUE_SHARES')"
          :to="{ name: 'revenue-shares' }"
        >
          <v-list-item-icon>
            <v-icon color="primary">mdi-rhombus-split</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.revenue_shares_report")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="{ name: 'agency-manager' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-rhombus-split</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.agency_manager_report")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="{ name: 'meal-plan-report' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-coffee</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $lang("main.titles.meal_plan_report") }}</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="{ name: 'inhouse-guests-report' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-home-account</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{
                $lang("main.titles.inhouse_guests_report")
              }}</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="{ name: 'reservation-extras-report' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-plus-box-multiple</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $lang("main.titles.reservation_extras") }}</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="{ name: 'work-orders-report' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-account-hard-hat</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $lang("main.titles.work_orders") }}</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-divider></v-divider>
      <v-list-group>
        <template v-slot:activator>
          <v-list-item-icon>
            <v-icon color="teal">mdi-cog</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $lang("main.titles.settings") }}
            </v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list-item v-if="$can('VIEW_COMPANIES')" :to="{ name: 'companies' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-briefcase</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $lang("main.titles.companies") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="$can('VIEW_PROPERTIES')"
          :to="{ name: 'properties' }"
        >
          <v-list-item-icon>
            <v-icon color="primary">mdi-office-building</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $lang("main.titles.properties") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="$can('CREATE_USERS')" :to="{ name: 'users' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-account-multiple</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.users")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="$can('CREATE_DERIVATION_RULES')"
          :to="{ name: 'derivations' }"
        >
          <v-list-item-icon>
            <v-icon color="primary">mdi-sitemap</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $lang("main.titles.derivations") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="$can('VIEW_GOOGLE_SHEETS')"
          :to="{ name: 'room-type-google-sheets' }"
        >
          <v-list-item-icon>
            <v-icon color="primary">mdi-google-spreadsheet</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.room_type_google_sheet")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="$can('CREATE_BOOKING_NETWORKS')"
          :to="{ name: 'booking-networks' }"
        >
          <v-list-item-icon>
            <v-icon color="primary">mdi-web-box</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.booking_networks")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- <v-list-item
          href="http://channel.ciaobooking.com"
          target="_blank"
          v-if="$can('VIEW_CHANNEL_MANAGER_CONNECTIONS')"
        >
          <v-list-item-icon>
            <v-icon color="red">mdi-transit-connection-variant</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.channel_manager")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->
      </v-list-group>
      <v-list-group
        v-if="$can('INTERNAL_SUPPORT') || $role('INTERNAL_SALES')"
        group="admin"
      >
        <template v-slot:activator>
          <v-list-item-icon>
            <v-icon color="red">mdi-alert-decagram</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.admin")
            }}</v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list-item v-if="$can('CREATE_HELPS')" :to="{ name: 'helps' }">
          <v-list-item-icon>
            <v-icon color="blue">mdi-help-circle</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.helps")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="$can('CREATE_TOURS')" :to="{ name: 'tours' }">
          <v-list-item-icon>
            <v-icon color="blue">mdi-school</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.tours")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="$can('VIEW_ANNOUNCEMENTS')"
          :to="{ name: 'Announcements' }"
        >
          <v-list-item-icon>
            <v-icon color="primary">mdi-rss</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.announcements")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="{ name: 'Amenities' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-format-list-bulleted-type</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.amenities")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="{ name: 'company-payments' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-cash-multiple</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Pagamenti</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="{ name: 'company-invoices' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-file-sign</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Fatture</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="{ name: 'fonts' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-format-font</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $lang("main.titles.fonts") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="{ name: 'global-settings' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-cog</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $lang("main.titles.global-settings") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="{ name: 'subscription-coupons' }">
          <v-list-item-icon>
            <v-icon color="yellow darken-2">mdi-sale</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.subscription_coupons")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="$can('VIEW_ACTIVITY_LOGS')"
          :to="{ name: 'activity-logs' }"
        >
          <v-list-item-icon>
            <v-icon>mdi-math-log</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.activity_logs")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-group v-if="$can('INTERNAL_SUPPORT')" group="octorate">
        <template v-slot:activator>
          <v-list-item-icon>
            <v-icon color="rgb(0, 178, 186)">mdi-network</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Octorate</v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list-item :to="{ name: 'octorate-accommodations' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-office-building</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.octorate_accommodations")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="{ name: 'octorate-reservations' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-format-list-bulleted</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $lang("main.titles.octorate_reservations")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="{ name: 'octorate-calendar-sync' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-calendar-sync</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $lang("main.titles.octorate_calendar_sync") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-group v-if="$can('INTERNAL_SUPPORT')" group="ciao-channel">
        <template v-slot:activator>
          <v-list-item-icon>
            <v-icon color="blue">mdi-network</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>CiaoChannel</v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list-item :to="{ name: 'ciao-channel-rates-sync' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-calendar-sync</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title> Sincro Calendario </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="{ name: 'ciao-channel-connections' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-circle-small</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title> Connessioni </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-item v-if="$can('VIEW_TICKETS')" :to="{ name: 'tickets' }">
        <v-list-item-icon>
          <v-icon color="red">mdi-lifebuoy</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ $lang("main.titles.support") }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="$can('VIEW_PROPERTY_OWNERS')"
        href="https://owner.ciaobooking.com"
        target="_blank"
      >
        <v-list-item-icon>
          <v-icon>mdi-account-cash</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ $lang("main.titles.owners_portal") }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="$can('VIEW_POINT_OF_SALES')"
        href="https://pos.ciaobooking.com"
        target="_blank"
      >
        <v-list-item-icon>
          <v-icon>mdi-cash-register</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ $lang("main.titles.point_of_sales") }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="$can('VIEW_ANNOUNCEMENTS')" :to="{ name: 'news' }">
        <v-list-item-icon>
          <v-icon color="primary">mdi-rss</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ $lang("main.titles.announcements") }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "CiaoBookingSidebar",
  computed: {
    ...mapState({
      sidebar: (state) => state.settings.sidebar
    })
  }
};
</script>
